module.exports = __webpack_public_path__ + "img/ntpp2-1.f5d9b17e.png";